// extracted by mini-css-extract-plugin
module.exports = {"main_page_v2_elec_detail_block_wrapper":"ElecDetailBlock_main_page_v2_elec_detail_block_wrapper__1hID0"};